import script from "./TextInputConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInputConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./TextInputConfirmModal.vue?vue&type=style&index=0&id=5f3f703a&lang=scss&scoped=true"

import exportComponent from "/home/atsuser/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3f703a"]])

export default __exports__